import type { ReactNode } from 'react'

interface HubPageProps {
  /** Shrink-0 chrome: title/control row, summary strip */
  chrome?: ReactNode
  /** Primary work surface — scrolls internally; must fill remaining height */
  children: ReactNode
  /** Shrink-0 footer: pagination, bulk bar */
  footer?: ReactNode
  className?: string
}

/**
 * Viewport-locked hub (MBA pipeline pattern).
 * Parent shell must be h-dvh + overflow hidden; this fills remaining main height.
 * Long lists scroll inside `children`, never the document.
 */
export function HubPage({ chrome, children, footer, className = '' }: HubPageProps) {
  return (
    <section className={`hub-page${className ? ` ${className}` : ''}`}>
      {chrome ? <div className="hub-page__chrome">{chrome}</div> : null}
      <div className="hub-page__body">{children}</div>
      {footer ? <div className="hub-page__footer">{footer}</div> : null}
    </section>
  )
}
